import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import BrandsMarquee from '../components/BrandsMarquee';
import Tools from '../components/Tools';
import Stats from '../components/Stats';
import PressBar from '../components/PressBar';
import Reviews from '../components/Reviews';
import Pricing from '../components/Pricing';
import PlanCompare from '../components/PlanCompare';
import TiktokPricing from '../components/TiktokPricing';
import ClientStories from '../components/ClientStories';
import Faq from '../components/Faq';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="bg-white text-[#0a1930] overflow-x-hidden">
      <Navbar />
      <Hero />
      <BrandsMarquee />
      <Tools />
      <Stats />
      <PressBar />
      <ClientStories />
      <Reviews />
      <Pricing />
      <TiktokPricing />
      <PlanCompare />
      <Faq />
      <Footer />
    </div>
  );
};

export default Home;
